<template>
  <div>
    <van-popup
      v-model="show"
      position="top"
      :style="{ height: 'auto' }">
      <div class="filter-detail">
        <div class="title">查询类型:</div>
        <div class="pi-divider margin-top-super"></div>
        <div class="grid">
          <div class="grid-item" v-for="(item, index) in queryTypes" :key="index" :class="{'checked': item.checked}"
               @click="onItemCheck(item, queryTypes)">
            {{item.name}}
          </div>
        </div>

        <div class="title margin-top-big">时间跨度:</div>
        <div class="pi-divider margin-top-super"></div>
        <div class="grid">
          <div class="grid-item" v-for="(item, index) in timeTypes" :key="index" :class="{'checked': item.checked}"
               @click="onItemCheck(item, timeTypes)">
            {{item.name}}
          </div>
        </div>
        <div class="title margin-top-big">日期查询(日期范围不能超过6个月):</div>
        <div class="date-query">
          <div class="date-input-time" @click="openPickTimeDialog(0)">
            {{startTime | formatDate }}
          </div>
          <div class="date-divider"></div>
          <div class="date-input-time" @click="openPickTimeDialog(1)">
            {{endTime | formatDate }}
          </div>
        </div>
        <div class="button-bar" @click="reset">
          <div class="button2">
            重置
          </div>
          <div class="button1" @click="onFilterButtonClick">
            搜索
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showTimePicker"
               position="bottom">
      <van-datetime-picker
        v-model="dateTimePickDate"
        type="date"
        :style="{ height: '50%' }"
        :min-date="minDate"
        v-on:confirm="onTimePickClick(true)"
        v-on:cancel="onTimePickClick"

      />
    </van-popup>
  </div>
</template>

<script>
import { Popup, Grid, GridItem, DatetimePicker } from 'vant';
import { getCurrentMonthFirstDate } from '@/common/old/public/date-format';

export default {
  name: 'filter-view',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Boolean,
    filterData: Object
  },
  components: {
    [Popup.name]: Popup,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [DatetimePicker.name]: DatetimePicker
  },
  watch: {
    value(newValue) {
      this.show = newValue;
    },
    show(newValue) {
      if (!newValue) {
        this.$emit('change', false);
      }
    }
  },
  mounted() {
    this.show = this.value;
  },
  data() {
    return {
      show: false,
      showTimePicker: false,
      chooseTime: 0, // 0 开始，1结束
      startTime: this.filterData.startTime || getCurrentMonthFirstDate(),
      endTime: this.filterData.endTime || new Date(),
      dateTimePickDate: null,
      minDate: new Date(2000, 1),
      queryTypes: [
        {
          checked: true,
          name: '全部',
          id: null
        },
        {
          checked: false,
          name: '充值',
          id: 2
        },
        {
          checked: false,
          name: '消费',
          id: 3
        },
        {
          checked: false,
          name: '退款',
          id: 4
        }
      ],
      timeTypes: [
        {
          checked: true,
          name: '近1月',
          id: 1
        },
        {
          checked: false,
          name: '近3月',
          id: 2
        },
        {
          checked: false,
          name: '近6月',
          id: 3
        }
      ]
    };
  },
  methods: {
    reset() {
      this.startTime = getCurrentMonthFirstDate();
      this.endTime = new Date();
      this.onItemCheck(this.queryTypes[0], this.queryTypes);
      this.onItemCheck(this.timeTypes[0], this.timeTypes);
    },
    onFilterButtonClick() {
      this.$emit('change', false);
      let filterData = {
        startTime: this.startTime,
        endTime: this.endTime,
        queryTypes: this.queryTypes.filter(item => item.checked)[0].id,
        timeTypes: this.timeTypes.filter(item => item.checked)[0].id
      };
      this.$emit('onConfirm', filterData);
      console.log(filterData);
    },
    onItemCheck(item, list) {
      list.forEach(listItem => {
        listItem.checked = item.name === listItem.name;
      });
    },
    onTimePickClick(confirm) {
      if (confirm) {
        if (this.chooseTime === 0) {
          this.startTime = this.dateTimePickDate;
        } else {
          this.endTime = this.dateTimePickDate;
        }
      }
      this.showTimePicker = false;
    },
    openPickTimeDialog(type) {
      this.showTimePicker = true;
      this.chooseTime = type;
      if (type === 0) {
        console.log("??")
      }
    }
  }
};
</script>

<style scoped lang="less">
.filter-detail {
  padding: 0.2rem;
  box-sizing: border-box;
  .title {
    font-size: 0.28rem;
    color: #333333;
  }
  .grid {
    display: flex;
    flex-wrap: wrap;
    .grid-item {
      flex-basis: 31.3333%;
      background: #F7F7F7;
      border-radius: 0.1rem;
      padding: 0.2rem 0;
      text-align: center;
      box-sizing: border-box;
      margin-right: 2%;
      margin-top: 0.2rem;
      font-size: 0.32rem;
      border: #F7F7F7 1px solid;
      &.checked {
        background: rgba(20, 204, 128, 0.13);
        border-radius: 0.1rem;
        border: #14CC80 1px solid;
        color: #14CC80;
      }
    }
  }
  .date-query {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.2rem;
    .date-input-time {
      text-align: center;
      flex-basis: 38.3333%;
      padding: 0.2rem;
      background:rgba(232,232,232,1);
      border-radius: 0.1rem;
    }
    .date-divider {
      width: 8%;
      height: 1px;
      background-color: #dcdcdc;
    }
  }
  .button-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .button1{
      flex: 2;
      height: 0.8rem;
      background:rgba(20,204,128,1);
      border-radius:0.01rem;
      text-align: center;
      color: white;
      font-size: 0.34rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0.4rem 0.2rem;
    }
    .button2{
      flex: 1;
      height: 0.8rem;
      border-radius:0.01rem;
      border:1px solid rgba(20,204,128,1);
      text-align: center;
      color: #14CC80;
      font-size: 0.34rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0.4rem 0.2rem;
    }
  }
}
</style>
